module.exports = __webpack_public_path__ + "img/main-bg.ab6ae146.png";